<template>
  <div class="page page-shell">
    <van-nav-bar :title="$t('setting.login_pwd_tip')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="content">
      <div class="hero-card">
        <div class="hero-badge">{{ $t("setting.login_pwd") }}</div>
        <div class="hero-title">{{ $t("setting.login_pwd_tip") }}</div>
        <div class="hero-desc">{{ userInfo.username || $t("my.personal_center") }}</div>
      </div>

      <div class="form-card">
        <div class="field-block">
          <label>{{ $t("setting.old_pwd") }}</label>
          <van-field
            v-model="old_password"
            type="password"
            :border="false"
            class="input"
            :placeholder="$t('setting.old_pwd_tip')"
          />
        </div>
        <div class="field-block">
          <label>{{ $t("setting.new_pwd") }}</label>
          <van-field
            v-model="o_new_password"
            type="password"
            :border="false"
            class="input"
            :placeholder="$t('setting.new_pwd_tip')"
          />
        </div>
        <div class="field-block">
          <label>{{ $t("setting.new_tip") }}</label>
          <van-field
            v-model="t_new_password"
            type="password"
            :border="false"
            class="input"
            :placeholder="$t('setting.new_again_tip')"
          />
        </div>
      </div>

      <van-button class="action-btn" type="primary" @click="save()">
        {{ $t("setting.save") }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password: "",
      t_new_password: "",
      old_password: "",
      userInfo: {},
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    save() {
      if (
        this.o_new_password === "" ||
        this.t_new_password === "" ||
        this.old_password === ""
      ) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (this.o_new_password !== this.t_new_password) {
        this.$toast(this.$t("setting.pwd_error"));
        return false;
      }
      this.$http({
        method: "get",
        data: {
          old_password: this.old_password,
          new_password: this.o_new_password,
        },
        url: "user_set_loginpw",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          setTimeout(() => {
            localStorage.clear();
            this.$router.push("Login");
          }, 500);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
    }
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";

.page-shell {
  min-height: 100%;
  background: linear-gradient(#1a1a1a, #000000) !important;
}

.content {
  padding: 16px;
}

.hero-card {
  padding: 20px;
  border-radius: 18px;
  border: 1px solid #444;
  background: linear-gradient(to bottom right, #33251a, #1b1435);
  margin-bottom: 16px;
}

.hero-badge {
  display: inline-flex;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 24px;
}

.hero-title {
  margin-top: 12px;
  color: #f4c57d;
  font-size: 36px;
  font-weight: 700;
}

.hero-desc {
  margin-top: 8px;
  color: #ddd;
  font-size: 24px;
}

.form-card {
  padding: 16px;
  border-radius: 18px;
  border: 1px solid #2a2a2a;
  background: #141419;
}

.field-block {
  margin-bottom: 14px;
}

.field-block:last-child {
  margin-bottom: 0;
}

.field-block label {
  display: block;
  margin-bottom: 8px;
  color: #fff;
  font-size: 26px;
  font-weight: lighter !important;
}

.input {
  border-radius: 14px;
  border: 1px solid #2a2a2a;
  background: #111015;
  padding: 8px 14px;
}

::v-deep .input input {
  color: #ccc;
  font-size: 28px;
}

::v-deep .input input::placeholder {
  color: #666;
}

.action-btn {
  margin-top: 18px;
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 18px;
  color: #111;
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(to right, #f4c57d, #f5a452);
}
</style>
